<template>
  <el-dialog
          title="流水概览详情"
          :visible.sync="dialogVisible"
          @opened="dialogOpen"
          width="90vw"
  >
    <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            size="mini"
            style="margin-bottom: -18px;"
    >

      <el-form-item
              label="订单号"
              prop="order_id"
      >
        <el-input
                v-model="searchForm.order_id"
                placeholder="订单号"
                style="width: 100px;"
        />
      </el-form-item>

      <el-form-item
      >
        <el-date-picker
                v-model="pickerValue"
                type="daterange"
                align="right"
                size="small"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          ></el-date-picker>
      </el-form-item>

      <el-form-item
              prop="stat"
      >
        <el-select
                class="filter-item"
                v-model="searchForm.stat"
                placeholder="支付状态"
                style="width: 100px;"
        >
          <el-option
                  v-for="item in ztOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
                type="primary"
                @click="handleSearchFormSubmit"
        >
          <d2-icon name="search" /> 查询
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-button @click="handleSearchFormReset">
          <d2-icon name="refresh" /> 重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
            :data="tableData"
            v-loading="loading"

            size="small"
            stripe
            highlight-current-row
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
    >

      <el-table-column
              label="订单号"
      >
        <template slot-scope="scope">
          {{scope.row.order_id}}
        </template>
      </el-table-column>
      <el-table-column
              label="支付订单号"
      >
        <template slot-scope="scope">
          {{scope.row.pay_order_id}}
        </template>
      </el-table-column>

      <el-table-column
              label="用户名称"
      >
        <template slot-scope="scope">
          {{scope.row.user_name}}
        </template>
      </el-table-column>
      <el-table-column
              label="用户头像"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.user_img_url!=null && scope.row.user_img_url!=''">
            <img :src= "getImgUrl2(scope.row)" style="width: 100px;height: 100px; "/>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="订单金额"
      >
        <template slot-scope="scope">
          {{scope.row.amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="下单时间"
      >
        <template slot-scope="scope">
          {{scope.row.insert_time2}}
        </template>
      </el-table-column>
      <el-table-column
              label="支付状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.stat==0">
            未支付
          </div>
          <div v-else-if="scope.row.stat==1">
            已支付
          </div>
          <div v-else-if="scope.row.stat==2">
            支付失败
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="是否团长"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.is_chief==0">
            是
          </div>
          <div v-else-if="scope.row.is_chief==1">
            否
          </div>

        </template>
      </el-table-column>

      <el-table-column
              label="是否中奖"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.stat_order==1 || scope.row.stat_order==2">
            <div v-if="scope.row.is_win==0">
              未中奖
            </div>
            <div v-else-if="scope.row.is_win==1">
              已中奖
            </div>
          </div>
        </template>
      </el-table-column>


      <el-table-column
              label="拼团商品名称"
      >
        <template slot-scope="scope">

          {{scope.row.good_name}}
        </template>
      </el-table-column>

      <el-table-column
              label="拼团商品图片"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.good_url!=null && scope.row.good_url!=''">




            <span v-for="(item,index) in scope.row.good_url.split(',')">
              <span v-if="index==0">
                 <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl(scope.row)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 100px; "></video>
              </span>
              <span v-else>
                 <img :src= "getImgUrl(scope.row)" style="width: 200px;height: 100px; "/>
              </span>
              </span>
          </span>


          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="收件人"
      >
        <template slot-scope="scope">

          {{scope.row.consignee}}
        </template>
      </el-table-column>

      <el-table-column
              label="收货人电话"
      >
        <template slot-scope="scope">

          {{scope.row.consignee_tel}}
        </template>
      </el-table-column>

      <el-table-column
              label="收货人地址"
      >
        <template slot-scope="scope">

          {{scope.row.consignee_address}}
        </template>
      </el-table-column>

      <el-table-column
              label="快递名称"
      >
        <template slot-scope="scope">

          {{scope.row.express_name}}
        </template>
      </el-table-column>

      <el-table-column
              label="快递单号"
      >
        <template slot-scope="scope">


          <div v-if="scope.row.express_no!=null && scope.row.express_no!=''">
            <el-button type="primary" plain size="mini"    @click="aaaa()">{{scope.row.express_no}}</el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.is_qr==0 && scope.row.stat==1">
            <div v-if="scope.row.stat_order==0">
              拼团中
            </div>
            <div v-if="scope.row.stat_order==1 || scope.row.stat_order==2">
              已退款
            </div>
          </div>
          <div v-else-if="scope.row.is_qr==1">
            已收货
          </div>
          <div v-else-if="scope.row.is_qr==2">
            待发货
          </div>
          <div v-else-if="scope.row.is_qr==3">
            待收货
          </div>

        </template>
      </el-table-column>

      <el-table-column
              label="售后状态"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.stat_order==1">

            <div v-if="scope.row.is_win==1">
              <div v-if="scope.row.is_refund==1">
                换货完成
              </div>
              <div v-else-if="scope.row.is_refund==2">
                卖家已同意换货,等待买家寄商品
              </div>
              <div v-else-if="scope.row.is_refund==3">
                商家拒绝换货申请:  {{scope.row.reject_reason}}
              </div>
              <div v-else-if="scope.row.is_refund==4">
                换货申请中,等待卖家处理
              </div>

            </div>
          </div>


        </template>
      </el-table-column>



    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
              :current-page="page.current"
              :page-size="page.size"
              :total="page.total"
              :page-sizes="[1,10,50,100, 200, 300, 400]"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: -10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

  </el-dialog>

</template>
<script>
  import * as agentService from "@/api/sys/agent";
  import * as userService from "@/api/sys/user";
  import util from '@/libs/util.js'
  export default {
    name: "threeagentEditForm",
    props: {
      agentid: String,
      pickerValue2: String,
      pickerValue3: String,
      value: Boolean
    },
    data() {
      return {
        loading: false,
        pos:0,
        dialogVisible: false,
        tableData: [],
        pickerValue: [],
        supplierNamearr1:[],
        ztOptions: [
          {
            value: "0",
            label: "未支付"
          },
          {
            value: "1",
            label: "支付成功"
          },
          {
            value: "2",
            label: "支付失败"
          }
        ],
        searchForm: {
          order_id:"",
          stat:""

        },
        page: {
          current: 1,
          size: 10,
          total: 0
        },
        sort: {
          prop: "",
          order: ""
        }
      };
    },
    watch: {
      value(val) {
        this.dialogVisible = val;
      },
      dialogVisible(val) {
        this.$emit("input", val);
      }
    },
    methods: {

      dateConversion(value){
        var d = new Date(value);
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        console.info("===========date========="+date);
        return date;
      },
      dialogOpen() {
        this.$refs.searchForm.resetFields();
        this.pickerValue=[this.pickerValue2,this.pickerValue3];
        this.getTableData33();

      },
      getTableData33() {

        console.info("===========ddddddddd========="+this.pickerValue[0]);
        let query = {
          pageIndex: this.page.current,
          pageSize: this.page.size,
          sortBy: this.sort.prop,
          group_id: this.agentid,
          start_time:this.pickerValue[0],
          end_time:this.pickerValue[1],
          descending: this.sort.order === "descending",
          filter: this.searchForm
        };
        agentService.myGrouporderUserlist(query).then(data => {
          this.tableData = data.rows;
          this.page.total = data.totalCount;
          //this.supplierNamesetdates(data.rows);
        });
      },
      getImgUrl2(row){
        return row.user_img_url;
      },
      handleSearchFormSubmit() {
        this.getTableData33();
      },
      handleSearchFormReset() {
        this.$refs.searchForm.resetFields();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleSortChange(val) {
        this.sort.prop = val.prop;
        this.sort.order = val.order;
        this.getTableData33();
      },
      handleSizeChange(val) {
        this.page.size = val;
        this.getTableData33();
      },
      handleCurrentChange(val) {
        this.page.current = val;
        this.getTableData33();
      },
      aaaa(){
        window.open("https://www.kuaidi100.com/","_blank");
      },
      getImgUrl(row){
        var good_url=row.good_url;
        if(good_url.match(",")){
          var str = good_url.split(',');
          good_url=str[0];
        }

        return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
      },
      close() {
        this.$refs["searchForm"].resetFields();
        this.dialogVisible = false;
      }
    }
  };
</script>
<style>
  .customWidth{
    width:90vw;
  }
</style>
